import axios from 'axios'
import {
  AIInterpretationFilterModel,
  FilterQueryParams,
  PaginationInfo,
  RequestorRow,
} from './types'

const API_URL = process.env.REACT_APP_API_URL

interface AccountApiRow {
  code: string
  firstName: string
  lastName: string
  email: string
  avatar?: string | null
  profileImage?: string | null
  pinCodeString?: string | null
  role: string
  customerName: string
  accountStatus: string
  isConfirmed: boolean
  aiInterpretationPermission: boolean
}

interface FilterResponse {
  data: AccountApiRow[]
  payload?: {
    pagination?: PaginationInfo
  }
}

function mapAccountToRow(account: AccountApiRow): RequestorRow {
  return {
    userId: account.code,
    firstName: account.firstName,
    lastName: account.lastName,
    email: account.email,
    avatar: account.avatar ?? account.profileImage,
    pinCodeString: account.pinCodeString,
    role: account.role,
    customerName: account.customerName,
    accountStatus: account.accountStatus,
    isConfirmed: account.isConfirmed,
    aiInterpretationPermission: account.aiInterpretationPermission ?? false,
  }
}

function buildQueryString(params: FilterQueryParams): string {
  const parts = [
    `page=${params.page}`,
    `items_per_page=${params.items_per_page}`,
    `order=${encodeURIComponent(params.order)}`,
  ]
  if (params.search) parts.push(`search=${encodeURIComponent(params.search)}`)
  if (params.sort) parts.push(`sort=${encodeURIComponent(params.sort)}`)
  return parts.join('&')
}

export async function fetchAIInterpretationRequestors(
  customerId: number,
  query: FilterQueryParams,
  filter: AIInterpretationFilterModel
): Promise<{rows: RequestorRow[]; pagination: PaginationInfo}> {
  const response = await axios.post<FilterResponse>(
    `${API_URL}/CustomerSettings/ai-interpretation/${customerId}/filter?${buildQueryString(query)}`,
    {
      status: filter.status,
      roles: filter.roles,
      joinDate: filter.joinDate || null,
      loginDate: filter.loginDate || null,
    }
  )

  const pagination = response.data.payload?.pagination ?? {
    page: query.page,
    from: 0,
    to: 0,
    total: 0,
    last_page: 1,
    items_per_page: query.items_per_page,
  }

  return {
    rows: (response.data.data ?? []).map(mapAccountToRow),
    pagination,
  }
}

export async function saveAIInterpretationPermissions(
  customerId: number,
  permissions: Array<{userId: string; aiInterpretationPermission: boolean}>
): Promise<void> {
  await axios.put(`${API_URL}/CustomerSettings/ai-interpretation/${customerId}`, {
    permissions,
  })
}
